import React from "react";

const tocItems = [
  { href: "#when", title: "When to Migrate", sub: "Key migration triggers" },
  { href: "#why",  title: "Why Migrate",     sub: "Business & technical reasons" },
  { href: "#use-cases", title: "Use Cases",  sub: "Real-world applications" },
];

export default function MigrationTOC() {
  return (
    <section className="px-6 py-12 bg-primary">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-semibold mb-6 text-white">On This Page</h2>
        <div className="grid md:grid-cols-3 gap-4">
          {tocItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="p-4 bg-primary-soft/50 rounded-lg hover:bg-primary-soft transition-colors border border-primary-soft"
            >
              <div className="font-semibold text-white mb-1">{item.title}</div>
              <div className="text-sm text-white/60">{item.sub}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}